<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.root"
  >
    <div
      :disabled="disabled"
      @click.stop="onClick"
      @mousedown.stop="e => $emit('mousedown', e)"
      :class="$style.container"
      :style="style.container"
    >
      <div
        :disabled="disabled"
        :class="$style.button"
        :style="style.button"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
  import { CssStyleProcessor } from '@js/vue-style-utils'

  export default {
    name: 'BaseButton',
    inheritAttrs: false,
    props: {
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      styleConfig: {
        type: Object,
        required: false,
        default: () => {},
      },
      truncate: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: function () {
      return {
        style: {
          button: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          },
          container: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            whiteSpace: 'nowrap',
            width: '100%',
          },
          root: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            width: 'fit-content',
          },
        },
      };
    },
    created: function () {
      const proc = new CssStyleProcessor('--v2-base-button');

      Object.assign(
        this.style.button,
        proc.getExtendedStyle(this.styleConfig.button, 'button'),
      );
      Object.assign(
        this.style.container,
        proc.getExtendedStyle(this.styleConfig.container, 'container'),
      );
      Object.assign(
        this.style.root,
        this.styleConfig.root,
      );

      if (this.truncate) {
        Object.assign(
          this.style.button,
          {
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          },
        );
        Object.assign(
          this.style.container,
          {
            minWidth: 0,
          },
        );
        Object.assign(
          this.style.root,
          {
            minWidth: 0,
          },
        );
      }
    },
    methods: {
      onClick: function (e) {
        if (this.disabled) {
          return;
        }
        this.$emit('click', e);
      },
      onMousedown: function (e) {
        if (this.disabled) {
          return;
        }
        this.$emit('mousedown', e);
      },
    },
  };
</script>

<style lang="stylus" module>
  .button
    color var(--v2-base-button-button-color)
    font-family var(--v2-base-button-button-font-family)
    font-size var(--v2-base-button-button-font-size)
    font-weight var(--v2-base-button-button-font-weight)
    text-decoration var(--v2-base-button-button-text-decoration)
    &:hover
      color var(--v2-base-button-button-color-hover)
      font-family var(--v2-base-button-button-font-family-hover)
      font-size var(--v2-base-button-button-font-size-hover)
      font-weight var(--v2-base-button-button-font-weight-hover)
      text-decoration var(--v2-base-button-button-text-decoration-hover)
    &:active
      color var(--v2-base-button-button-color-active)
      font-family var(--v2-base-button-button-font-family-active)
      font-size var(--v2-base-button-button-font-size-active)
      font-weight var(--v2-base-button-button-font-weight-active)
      text-decoration var(--v2-base-button-button-text-decoration-active)
    &[disabled]
      color var(--v2-base-button-button-color-disabled)
      font-family var(--v2-base-button-button-font-family-disabled)
      font-size var(--v2-base-button-button-font-size-disabled)
      font-weight var(--v2-base-button-button-font-weight-disabled)
      text-decoration var(--v2-base-button-button-text-decoration-disabled)

  .container
    background-color var(--v2-base-button-container-background-color)
    border var(--v2-base-button-container-border)
    border-radius var(--v2-base-button-container-border-radius)
    border-width var(--v2-base-button-container-border-width)
    box-shadow var(--v2-base-button-container-box-shadow)
    cursor var(--v2-base-button-container-cursor)
    &:hover
      background-color var(--v2-base-button-container-background-color-hover)
      border var(--v2-base-button-container-border-hover)
      border-radius var(--v2-base-button-container-border-radius-hover)
      border-width var(--v2-base-button-container-border-width-hover)
      box-shadow var(--v2-base-button-container-box-shadow-hover)
      cursor var(--v2-base-button-container-cursor-hover)
    &:active
      background-color var(--v2-base-button-container-background-color-active)
      border var(--v2-base-button-container-border-active)
      border-radius var(--v2-base-button-container-border-radius-active)
      border-width var(--v2-base-button-container-border-width-active)
      box-shadow var(--v2-base-button-container-box-shadow-active)
      cursor var(--v2-base-button-container-cursor-active)
    &[disabled]
      background-color var(--v2-base-button-container-background-color-disabled)
      border var(--v2-base-button-container-border-disabled)
      border-radius var(--v2-base-button-container-border-radius-disabled)
      border-width var(--v2-base-button-container-border-width-disabled)
      box-shadow var(--v2-base-button-container-box-shadow-disabled)
      cursor var(--v2-base-button-container-cursor-disabled)
</style>
